import { BlogsSharedState } from 'mk2/apps/blogs/reducers';
import { AppState } from 'mk2/reducers';

export const getBlogspSharedState = (state: AppState): BlogsSharedState =>
    state.containers.blogs.shared;
